// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './router/index';
import VueRouter from 'vue-router';
import Vuex from 'vuex'
import store from './vuex/store'
import common from '../static/common.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import qs from 'qs'
import util from './util'
// 全局组件

Vue.config.productionTip = false
Vue.prototype.$common = common;
Vue.config.debug = true;
Vue.config.devtools = true;

Vue.use(VueRouter);
Vue.use(Vuex)
Vue.use(ElementUI);
const router = new VueRouter({
  routes
})


const appKey=common.appKey();
router.beforeEach((to, from, next) => {

  let sessionUser = JSON.parse(window.sessionStorage.getItem(appKey));
  if (to.meta.requireAuth){
    if(!util.isEmptyObject(sessionUser)){ //如果用户已登录
      next()
    }else{
      next({
        path: '/login',
        query: {jumpUrl: to.fullPath}
      });
      instance.$store.state.watermarkStatus = false;
      instance.$store.state.loginStatus = false;
      instance.$notify({
        title: '温馨提示',
        message: '请先登录!',
        position: 'top-right'
      })
    }
  }else{
    if (!util.isEmptyObject(sessionUser)) //如果用户已登录
    {
      if (to.fullPath=='/login')  //如果是已经登录的，要跳到登录窗口，则返回到首页
      {
        location.reload()
        next({
          path: '/transInfo'
        })
      }else if (to.query.jumpUrl != undefined){
        next({
          path: to.query.jumpUrl
        })
      };
    } else {
      next();
    };
  }

});


const axiosIns = axios.create()
axiosIns.defaults.retry = 4
axiosIns.defaults.retryDelay = 1000
axiosIns.defaults.timeout = 5000
axiosIns.defaults.baseURL = common.getCallUrl();
// axios 实例添加拦截器
axiosIns.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // const token = window.localStorage.getItem('token')
  // 把token放到header里面
  // if (token) {
  //   config.headers['token'] = token
  // }
  if(config.method  === 'post' && config.headers['Content-Type'] !== 'multipart/form-data'){
    config.data = qs.stringify(config.data);
  }
  //加载动画等
  instance.$store.state.fullscreenLoading = true;
  console.log('数据请求中...')
  return config
}, function (error) {
  // 对请求错误进行修改
  console.log('错误的传参')
  return Promise.reject(error)
})

axiosIns.interceptors.response.use(function (response) {
  // 可在请求到结果后对数据进行修改
  return response
}, function (error) {
  // 请求错误时做些事
  // 请求超时的之后，抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    var config = error.config
    config.__retryCount = config.__retryCount || 0
    if (config.__retryCount >= config.retry) {
      return Promise.reject(error)
    }
    config.__retryCount += 1
    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        // console.log('resolve')
        resolve()
      }, config.retryDelay || 1)
    })
    return backoff.then(function () {
      return axiosIns(config)
    })
  } else {
    return Promise.reject(error)
  }
})
const ajaxMethod = ['get', 'post']
const api = {}
ajaxMethod.forEach((method) => {
  api[method] = function (url, data, config) {
    return new Promise(function (resolve, reject) {
      axiosIns[method](url, data, config).then((response) => {
        if (response.data.code === 500) {
          if(response.data.message){
            instance.$notify({
              title: '温馨提示',
              message: response.data.message,
              position: 'top-right'
            })
          }
        } else if (response.data.code === 404) {
          instance.$notify({
            title: '请求异常',
            message: response.data.message,
            position: 'top-right'
          })
        } else if (response.data.code === 300) {
          instance.$notify({
            title: '登录失效',
            message: '登录失效,请重新登录',
            position: 'top-right'
          })
          instance.$router.push({ path:"/login" });
          sessionStorage.removeItem(util.appKey());
          instance.$store.state.watermarkStatus = false;
          instance.$store.state.loginStatus = false;
        }  else if (response.data.code === 200) {
          resolve(response.data)
        }
      }).catch(function (error) {
        if (error.response) {
          instance.$notify({
            title: '温馨提示',
            message: '系统异常',
            position: 'top-right'
          })
        } else {
          instance.$notify({
            title: '温馨提示',
            message: '网络故障',
            position: 'top-right'
          })
          console.log(error)
          console.log('Error', error.message)
        }
        console.log(error.config)
      }).finally(function(){

        instance.$store.state.fullscreenLoading = false;
      })
    })
  }
})

Vue.prototype.$axios = api
let instance = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js